var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "relative",
      staticStyle: { width: "100%", margin: "0 auto", overflow: "hidden" },
      style: _vm.minHeight,
    },
    [
      _c("iframe", {
        ref: "iframe",
        staticClass: "absolute",
        staticStyle: {
          overflow: "hidden",
          "background-color": "transparent",
          width: "100%",
          height: "100%",
          top: "0px",
          left: "0",
          bottom: "0",
          padding: "10px",
        },
        attrs: {
          id: "show-iframe",
          title: "Report Section",
          src: "https://app.powerbi.com/view?r=eyJrIjoiMDU0NmI4YTUtZTQ3MS00M2I3LTkxNmYtN2EyM2ZkZWQxYjI5IiwidCI6IjY0ZjMzNDMxLWJiZjAtNDJiOC04MmVmLWJmNDUxYmQwZDg1ZCJ9",
          frameborder: "0",
          scrolling: "yes",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }